import { createContext, useContext } from "react"
import { useQuery } from "@tanstack/react-query"
import { useConfig } from "./ConfigProvider"
import { GetCrmEventTypes, CreateCRMEvent, GetCrmEvents, UpdateCRMEvent } from "../Services/CustomerService"
import { useAuth } from "./AuthProvider"
import { convertTextDateToDateObiect } from "../Helpers/ValidatorHelper"

const CrmContext = createContext()
const EMPTY_ARRAY = [] //stała referencja - zapobiega pętli renderów przy pustych danych

export const useCrm = () => {
    return useContext(CrmContext)
}

const CrmProvider = ({ children }) => {
    const { api } = useConfig()
    const { authState } = useAuth()

    // Słowniki CRM pobieramy tylko dla operatorów z uprawnieniem do obsługi kontaktów -
    // pozostali użytkownicy nigdy nie zobaczą modułu CRM, więc nie ma po co ich pobierać.
    const hasCrmAccess = Boolean(authState.user?.isOperator) && Number(authState.user?.upR_SYS_OBSLUGA_KONTAKTOW) > 0

    const { data: crmEventTypes } = useQuery({ //wszystkie typy
        queryKey: ['crm', 'eventTypes', 'all'],
        queryFn: async () => (await GetCrmEventTypes(api, null)).data,
        enabled: hasCrmAccess,
        staleTime: 60 * 60 * 1000,
    })

    const { data: crmEventTypesForContractor } = useQuery({ //tylko takie które występują dla danego custId
        queryKey: ['crm', 'eventTypes', authState.custId],
        queryFn: async () => (await GetCrmEventTypes(api, authState.custId)).data,
        enabled: hasCrmAccess && Boolean(authState.custId),
        staleTime: 60 * 60 * 1000,
    })

    const handleCreateCRMEvent = async (inputData) => {
        try {
            let formatedData = {
                custId: authState.custId,
                theme: inputData.topic,
                evaluation: inputData.grade,
                comments: inputData.note,
                eventDateTime: inputData.date,
                type: inputData.event,
            }
            let res = await CreateCRMEvent(api, formatedData)
            return res.data
        } catch (error) {
            console.log(error)
            return false
        }
    }

    const handleGetCrmEvents = async (pageNumber, pageSize, type, dateFrom, dateTo) => {
        if (authState.custId) {
            try {
                let res = await GetCrmEvents(api, authState.custId, pageNumber, pageSize, type, convertTextDateToDateObiect(dateFrom), convertTextDateToDateObiect(dateTo))
                return res.data
            } catch (error) {
                console.log(error)
                return []
            }
        }
    }

    const handleEditCrmEvent = async (recNo, type, theme, eventDateTime, evaluation, comments, name) => {
        try {
            let res = await UpdateCRMEvent(api, recNo, authState.custId, type, theme, convertTextDateToDateObiect(eventDateTime), evaluation, comments, name)
            return res.data
        } catch (error) {
            console.log(error)
            return false
        }
    }


    return <CrmContext.Provider value={{
        crmEventTypes: crmEventTypes ?? EMPTY_ARRAY,
        crmEventTypesForContractor: crmEventTypesForContractor ?? EMPTY_ARRAY,
        handleCreateCRMEvent,
        handleGetCrmEvents,
        handleEditCrmEvent,
    }} >
        {children}
    </CrmContext.Provider>
}

export default CrmProvider